import React from "react";

export default function Preloader({ isLoading }) {
  return (
    <>
      <div className={`preloader ${isLoading ? "active" : ""}`}>
        <div className="fantico_logo">
          <div className="clip_logo"></div>
        </div>
      </div>
    </>
  );
}
